import { call, put, select } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import { setLoading, setProcessing } from 'redux/slices/faqSlice'
import { addFaq, createFaq, getFaq, removeFaq, updateFaq } from '../requests/faqService'
import { setFaq } from 'redux/slices/faqSlice'
import { setUpdateFaq } from 'redux/slices/faqSlice'
import { setAppLoading } from 'redux/slices/authTokenSlice'

export function* handleGetFaq(action) {
  try {
    yield put(setLoading())
    const { data } = yield call(() => getFaq(action.payload))
    yield put(setFaq({ data }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    // yield put(setProvinces({error: errMsg}))
  }
}

export function* handleUpdateFaq(action) {
  try {
    const { data: payload, product_id } = action.payload
    yield put(setAppLoading(true))
    yield call(() => updateFaq(product_id, payload))
    yield put(setUpdateFaq(payload))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
    // yield put(setProvinces({error: errMsg}))
  } finally {
    yield put(setAppLoading(false))
  }
}

export function* handleRemoveFaq(action) {
  try {
    const { productId, faqId } = action.payload
    yield put(setProcessing(true))
    // yield put(setAppLoading(true))
    const {data} = yield call(() => removeFaq(productId, faqId))
    yield put(setFaq({data}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
    // yield put(setProvinces({error: errMsg}))
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleCreateFaq(action) {
  try {
    yield put(setProcessing(true))
    const {data} = yield call(() => createFaq(action.payload))
    yield put(setFaq({ data: data }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
    // yield put(setProvinces({error: errMsg}))
  } finally {
    yield put(setAppLoading(false))
  }
}

export function* handleAddFaq(action) {
  try {
    const { product_id, data: payload } = action.payload
    const { data } = yield call(() => addFaq(product_id, payload))
    yield put(setFaq({ data }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
    // yield put(setProvinces({error: errMsg}))
  } finally {
    yield put(setAppLoading(false))
  }
}
